import { render, staticRenderFns } from "./ship-map.vue?vue&type=template&id=2799141b&scoped=true"
import script from "./ship-map.vue?vue&type=script&lang=js"
export * from "./ship-map.vue?vue&type=script&lang=js"
import style0 from "./ship-map.vue?vue&type=style&index=0&id=2799141b&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799141b",
  null
  
)

export default component.exports